export default "__VITE_ASSET__fc4fe6d0__"